import { useDebugValue, useCallback } from "react";
import { useCalculation, useHasCalculation } from "../context";
import { getInNamespaced, existsInNamespaced } from "../../calculator/utils";
import { useTemplateDebugManager } from "../debugContext";
/**
 * _NOT_ influenced by whether or not "debug mode" is enabled
 */
export function useFieldIsVisibleInternal() {
    const hasCalc = useHasCalculation();
    const { defaultFieldVisibility, isFieldVisible, isEnabled, defaultFieldEnabled } = useCalculation("isFieldVisible", "isEnabled", "defaultFieldEnabled", "defaultFieldVisibility");
    return useCallback((field, defaultValue = false) => {
        if (!hasCalc)
            return true;
        if (field.hideIfDisabled) {
            let enabled = getInNamespaced(isEnabled, field.namespace, field.name);
            if (enabled == null) {
                enabled = getInNamespaced(defaultFieldEnabled, field.namespace, field.name, true);
            }
            if (enabled === false)
                return false;
        }
        const visible = getInNamespaced(isFieldVisible, field.namespace, field.name);
        if (visible != null)
            return visible;
        return getInNamespaced(defaultFieldVisibility, field.namespace, field.name, defaultValue);
    }, [
        defaultFieldEnabled,
        defaultFieldVisibility,
        hasCalc,
        isEnabled,
        isFieldVisible
    ]);
}
export function useFieldExists() {
    const { defaultFieldVisibility } = useCalculation("defaultFieldVisibility");
    return useCallback(field => existsInNamespaced(defaultFieldVisibility, field.namespace, field.name), [defaultFieldVisibility]);
}
/**
 * Influenced by whether or not "debug mode" is enabled
 */
export function useFieldIsVisible() {
    const isFieldVisible = useFieldIsVisibleInternal();
    const { isFieldVisible: isFieldvisibleDebug } = useTemplateDebugManager();
    return useCallback((field, defaultValue = false) => isFieldvisibleDebug(field, isFieldVisible(field, defaultValue)), [isFieldVisible, isFieldvisibleDebug]);
}
export function useIsAnyFieldVisible(field = [], ...fields) {
    const fieldIsVisible = useFieldIsVisible();
    const isAnyFieldVisible = fields.concat(field).some(f => fieldIsVisible(f));
    useDebugValue(isAnyFieldVisible);
    return isAnyFieldVisible;
}
export function useAreAllFieldsVisible(field = [], ...fields) {
    const fieldIsVisible = useFieldIsVisible();
    const areAllFieldsVisible = fields
        .concat(field)
        .every(f => fieldIsVisible(f));
    useDebugValue(areAllFieldsVisible);
    return areAllFieldsVisible;
}
//# sourceMappingURL=useIsAnyFieldVisible.js.map